import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-577f5a5c")

_pushScopeId("data-v-577f5a5c")
const _hoisted_1 = /*#__PURE__*/_createVNode("br", { class: "-pc" }, null, -1)
const _hoisted_2 = { class: "form__input" }
const _hoisted_3 = { class: "input__purpose" }
const _hoisted_4 = { class: "input__purpose-other" }
const _hoisted_5 = {
  for: "purpose",
  class: "-medium"
}
const _hoisted_6 = { class: "-required" }
const _hoisted_7 = { class: "input__files" }
const _hoisted_8 = {
  for: "purpose",
  class: "-medium"
}
const _hoisted_9 = { class: "request-form__footer--actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Alert = _resolveComponent("Alert")
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")
  const _component_RequestConfirm = _resolveComponent("RequestConfirm")
  const _component_RequestStep = _resolveComponent("RequestStep")
  const _component_Doctors = _resolveComponent("Doctors")
  const _component_DoctorItemOptions = _resolveComponent("DoctorItemOptions")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_FileList = _resolveComponent("FileList")
  const _component_FileUploader = _resolveComponent("FileUploader")
  const _component_FileViewer = _resolveComponent("FileViewer")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Button = _resolveComponent("Button")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _component_Form = _resolveComponent("Form")

  return (!_ctx.state.isLoading)
    ? (_openBlock(), _createBlock(_component_Form, {
        key: 0,
        class: "second-opinion__request__form",
        action: "",
        method: "",
        onSubmit: _ctx.saveConfirm
      }, {
        default: _withId(() => [
          (!!_ctx.alert.content)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                alert: _ctx.alert,
                "onUpdate:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert.content = ''))
              }, null, 8, ["alert"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CustomConfirmDialog, { group: "save" }),
          _createVNode(_component_RequestConfirm, {
            ref: "confirm$",
            accept: _ctx.goBack
          }, null, 8, ["accept"]),
          _createVNode(_component_PageFrame, {
            modelValue: _ctx.state.page,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.page = $event)),
            class: "form__content"
          }, {
            title: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("second opinion")), 1)
            ]),
            subtitle: _withId(() => [
              _createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.t("second-opinion-intro-1")) + " ", 1),
                _hoisted_1,
                _createTextVNode(" " + _toDisplayString(_ctx.t("second-opinion-intro-2")), 1)
              ])
            ]),
            content: _withId(() => [
              _createVNode(_component_RequestStep, {
                class: "request-step",
                kind: _ctx.RequestKindTypes.SecondOpinion,
                step: _ctx.state.page.valueOf()
              }, null, 8, ["kind", "step"]),
              _createVNode("div", _hoisted_2, [
                (_ctx.state.page === _ctx.PageStates.DOCTOR)
                  ? (_openBlock(), _createBlock(_component_Doctors, {
                      key: 0,
                      pDoctors: _ctx.doctors,
                      "onUpdate:pDoctors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.doctors = $event)),
                      onSelectedDoctor: _ctx.onSelectedDoctor,
                      required: true,
                      isEditable: true,
                      possibleTypes: _ctx.PossibleTypes.SECOND_OPINION,
                      doctorKey: _ctx.state.purpose.doctorKey?.valueOf(),
                      ref: "doctors$"
                    }, null, 8, ["pDoctors", "onSelectedDoctor", "possibleTypes", "doctorKey"]))
                  : _createCommentVNode("", true),
                (_ctx.state.page === _ctx.PageStates.PURPOSE)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      (!!_ctx.selectedDoctor)
                        ? (_openBlock(), _createBlock(_component_DoctorItemOptions, {
                            key: 0,
                            class: "selected-doctor",
                            doctor: _ctx.selectedDoctor,
                            isProfile: true
                          }, null, 8, ["doctor"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_3, [
                        _createVNode("div", _hoisted_4, [
                          _createVNode("label", _hoisted_5, [
                            _createTextVNode(_toDisplayString(_ctx.t("input chief complaint")), 1),
                            _createVNode("span", _hoisted_6, " (" + _toDisplayString(_ctx.t("required")) + ")", 1)
                          ]),
                          _createVNode(_component_Textarea, {
                            id: "purpose",
                            modelValue: _ctx.state.purpose.other,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.purpose.other = $event)),
                            rows: 12,
                            cols: 36
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_7, [
                        _createVNode("label", _hoisted_8, _toDisplayString(_ctx.t("attach files")), 1),
                        (_ctx.state.purpose.files && _ctx.state.purpose.files.length > 0)
                          ? (_openBlock(), _createBlock(_component_FileList, {
                              key: 0,
                              class: "upload-files",
                              list: _ctx.state.purpose.files,
                              id: _ctx.state.id,
                              requestKind: _ctx.RequestKindTypes.SecondOpinion,
                              onOnSelectedRow: _ctx.onSelectedRow,
                              onDeletedFile: _ctx.deletedFile
                            }, null, 8, ["list", "id", "requestKind", "onOnSelectedRow", "onDeletedFile"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_FileUploader, {
                          isEditable: true,
                          isAllowVideo: true,
                          isAllowZip: true,
                          url: _ctx.url,
                          onProgress: _ctx.filesProgress,
                          ref: "fileUploader$",
                          class: "file-uploader"
                        }, null, 8, ["url", "onProgress"]),
                        _createVNode(_component_Sidebar, {
                          visible: _ctx.state.visibleFull,
                          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.visibleFull = $event)),
                          baseZIndex: 1000,
                          position: "full",
                          style: {"overflow":"scroll"}
                        }, {
                          default: _withId(() => [
                            (_ctx.state.selectFile)
                              ? (_openBlock(), _createBlock(_component_FileViewer, {
                                  key: 0,
                                  select: _ctx.state.selectFile,
                                  isSidebar: false
                                }, null, 8, ["select"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["visible"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            action: _withId(() => [
              _createVNode("div", _hoisted_9, [
                (_ctx.state.page > 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "-button -medium -grey3",
                      onClick: _ctx.prev
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("previous")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.state.page < _ctx.totalPages - 1)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "-button -medium -royalBlue",
                      onClick: _ctx.next,
                      disabled: _ctx.isValidate ? false : true
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("next")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.state.page === _ctx.totalPages - 1)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: "-button -medium -royalBlue",
                      type: "submit",
                      disabled: _ctx.isValidate ? false : true
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("submit application")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["onSubmit"]))
    : _createCommentVNode("", true)
})